module.exports = __webpack_public_path__ + "static/img/nothing-data.8b533a4.gif";


//////////////////
// WEBPACK FOOTER
// ./static/nothing-data.gif
// module id = Z+3P
// module chunks = 1